module.exports = __webpack_public_path__ + "img/suspects_with_red_icon.8356e40b.png";